<div class="top-bar-container w-depth" [ngClass]="{'white-bar': whiteBar, 'promo': promoPage}">
  <div class="box">
    <div class="side-menu" *ngIf="whiteBar && isLoggedIn" (click)="sideNav()">
       <!-- && isLoggedIn -->
      <i class="wahii-icon-menu-bars"></i>
      <span>Menu</span>
    </div>
    <div class="logo-container">
      <i class="wahii-icon-wahii-logo-text"></i>
    </div>
    <div class="logo-container-white">
      <img src="./assets/svg/color_logo.svg">
    </div>
    <div class="menu-list" *ngIf="!promoPage">
      <ul>
        <li>
          <a href="/">Home</a>
        </li>
        <li>
          <a href="" class="active">Fuel Online</a>
        </li>
        <li>
          <a href="/faq">FAQ's</a>
        </li>
        <li>
          <a href="/distributor">Distributors</a>
        </li>

        <li>
          <a href="/press">Press</a>
        </li>
      </ul>
    </div>
  </div>
</div>
